"use client";
import { FC, MouseEventHandler, ReactNode } from "react";
import Link from "next/link";
import Conditional from "../Conditional/Conditional";
import { doesExist } from "@repo/shared-utils/common-utils";

interface LinkProps {
  key?: number | string;
  href?: string;
  children: ReactNode;
  className?: string;
  openInNewTab?: boolean | string;
  ctProps?: string;
  dlProps?: string;
  onClick?: MouseEventHandler<HTMLSpanElement>;
}

const BFLLink: FC<LinkProps> = ({
  href = "",
  children,
  className,
  openInNewTab = false,
  ctProps,
  dlProps,
  onClick,
}) => {
  const shouldOpenInNewTab = openInNewTab === "true" || openInNewTab === true;
  const linkTarget = shouldOpenInNewTab ? "_blank" : "_self";

  return (
    <>
      <Conditional if={doesExist(href)}>
        <Link
          href={href}
          className={className}
          target={linkTarget}
          onClick={onClick}
          {...(shouldOpenInNewTab && {
            rel: "noreferrer noopener",
          })}
          {...(ctProps && { "data-ct": ctProps })}
          {...(dlProps && { "data-dl": dlProps })}
        >
          {children}
        </Link>
      </Conditional>
      <Conditional if={!doesExist(href)}>
        <button className={className} onClick={onClick}>
          {children}
        </button>
      </Conditional>
    </>
  );
};

export default BFLLink;
